module.exports = __webpack_public_path__ + "static/media/arduino.4e9beaa6.png";